import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function generateProjectLlmPrompt(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_GENERATE_PROMPT,
    (organisationId, projectId, prompt, conversationId, previousItemId) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}/generate_prompt`,
          {
            prompt,
            conversation_id: conversationId,
            previous_item_id: previousItemId,
          },
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
